import Form from "../form/Form";
import { edit } from '../../slices/videoSlice';
import { appUrl } from "../../utils/fetch";
import PropTypes from 'prop-types';
import { Stack } from "@mui/system";
import VideoPreview from "./VideoPreview";
import { Box } from "@mui/system";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import UserTabs from "./UserTabs";

function Video(props) {
    const { id, closeFunc } = props;
    const isRequesting = false;
    const navigate = useNavigate();

    const videoData = useSelector((state) => state.video);
    const settings = useSelector((state) => state.settings);

    const [ openUser, setOpenUser ] = useState(false);
    
    return (
        <>
            {!openUser ? (
                <Stack direction={"row"} spacing={3}>
                    {isRequesting ? (
                        <Box sx={{ width: '100%', paddingTop: "30px" }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <Form 
                                inputs={!id ? {
                                    name: {
                                        label: "Title",
                                        field: "text",
                                    },
                                    title_slug: {
                                        label: "Slug",
                                        field: "text",
                                        slugify: "name"
                                    },
                                    description: {
                                        label: "Description",
                                        field: "textarea"
                                    },
                                    date_scheduled: {
                                        label: "Date Scheduled",
                                        field: "date",
                                        time: true
                                    },
                                    file: {
                                        label: "Browse for video",
                                        field: "upload",
                                        border: true
                                    },
                                    external_url: {
                                        label: "External URL",
                                        field: "text",
                                        placeholder: "Enter video URL (alternative to file upload)"
                                    },
                                    status: {
                                        label: "Status",
                                        field: "buttonswitch",
                                        data: [
                                            { id: 1, label: "Online", color: "green" },
                                            { id: 2, label: "Offline", color: "red" },
                                        ],
                                        width: 6
                                    },
                                    type: {
                                        label: "Type",
                                        field: "buttonswitch",
                                        data: [
                                            { id: 1, label: "Public" },
                                            { id: 2, label: "Private" },
                                            { id: 3, label: "Premium" },
                                        ],
                                        width: 6
                                    },
                                    categoriesNew: {
                                        label: "Categories",
                                        field: "multiselect",
                                        data: "content-categories-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "categories",
                                        extraFuncLabel: "New category"
                                    },
                                    tagsNew: {
                                        label: "Tags",
                                        field: "multiselect",
                                        data: "content-tags-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "tags",
                                        extraFuncLabel: "New tag",
                                        lowercase: true
                                    },
                                    channels: {
                                        label: "Channels",
                                        field: "multiselect",
                                        data: "channels-search",
                                        disableMultiple: true,
                                        extraFuncType: "addNew",
                                        extraFuncName: "channels",
                                        extraFuncLabel: "New channel",
                                    },
                                    models: {
                                        label: "Models",
                                        field: "multiselect",
                                        data: "models-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "models",
                                        extraFuncLabel: "New model",
                                    },
                                } : {
                                    name: {
                                        label: "Title",
                                        field: "text",
                                        ...(settings?.aiVideoTitle !== "false" ? { ai: true } : {}),
                                        slugField: "title_slug"
                                    },
                                    title_slug: {
                                        label: "Slug",
                                        field: "text",
                                        slugify: "name"
                                    },
                                    frontendUrl: {
                                        field: 'link'
                                    },
                                    description: {
                                        label: "Description",
                                        field: "textarea",
                                        border: true,
                                        ...(settings?.aiVideoDescription !== "false" ? { ai: true } : {}),
                                    },
                                    date_scheduled: {
                                        label: "Date Scheduled",
                                        field: "date",
                                        border: true,
                                        time: true
                                    },
                                    external_url: {
                                        label: "External URL",
                                        field: "text",
                                        placeholder: "Enter video URL (alternative to file upload)",
                                        border: true
                                    },
                                    status: {
                                        label: "Status",
                                        field: "buttonswitch",
                                        data: [
                                            { id: 1, label: "Online", color: "green" },
                                            { id: 2, label: "Offline", color: "red" },
                                        ],
                                        width: 6
                                    },
                                    type: {
                                        label: "Type",
                                        field: "buttonswitch",
                                        data: [
                                            { id: 1, label: "Public" },
                                            { id: 2, label: "Private" },
                                            { id: 3, label: "Premium" },
                                        ],
                                        width: 6
                                    },
                                    categoriesNew: {
                                        label: "Categories",
                                        field: "multiselect",
                                        data: "content-categories-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "categories",
                                        extraFuncLabel: "New category"
                                    },
                                    tagsNew: {
                                        label: "Tags",
                                        field: "multiselect",
                                        data: "content-tags-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "tags",
                                        extraFuncLabel: "New tag",
                                        lowercase: true
                                    },
                                    channels: {
                                        label: "Channels",
                                        field: "multiselect",
                                        data: "channels-search",
                                        disableMultiple: true,
                                        extraFuncType: "addNew",
                                        extraFuncName: "channels",
                                        extraFuncLabel: "New channel",
                                    },
                                    models: {
                                        label: "Models",
                                        field: "multiselect",
                                        data: "models-search",
                                        extraFuncType: "addNew",
                                        extraFuncName: "models",
                                        extraFuncLabel: "New model",
                                    },
                                    empty: {
                                        height: "calc(28vw - 240px)",
                                        field: "empty"
                                    }
                                }}
                                columns={2}
                                stateName="video"
                                dispatchFunc={edit}
                                api={`${appUrl}/api/video`}
                                navbar
                                detailId={id}
                                doneFunc={() => { if(closeFunc){closeFunc()} else {navigate(`/videos/list/page/1`)} }}
                                required={id && id !== "new" ? [ "name", "categoriesNew" ] : [ "name", "categoriesNew" ]}
                                validation={id && id !== "new" ? [ "notNull", "notNull" ] : [ "notNull", "notNull" ]}
                                customValidation={(formData) => {
                                    // For new videos, require either file or external_url
                                    if (!id || id === "new") {
                                        if ((!formData.file || !formData.file.name) && (!formData.external_url || !formData.external_url.trim())) {
                                            return { error: true, message: "Either a video file or external URL is required" };
                                        }
                                    }
                                    return { error: false };
                                }}
                            />
                            {id ? (
                                <VideoPreview
                                    dispatchFunc={edit}
                                    userDetail={() => setOpenUser(true)}
                                />
                            ) : null}
                        </>
                    )}
                </Stack>
            ) : (
                <div style={{width: "1200px"}}>
                    <UserTabs id={videoData.user_id} mainPage="videos" />
                </div>
            )}
        </>
    );
}

export default Video;

Video.propTypes = {
    id: PropTypes.number,
    closeFunc: PropTypes.func
};